/* OXX wishlist — client-side favourites (localStorage, guest).
   - toggle buttons: [data-oxx-wishlist] with data-wish-* attrs (PDP rose, card roses)
   - open trigger:   [data-oxx-wishlist-open] (navbar rose, mobile menu link)
   - drawer:         #oxx-wishlist-drawer (rendered once, globally)
   No framework: native <dialog> + delegated events. */
(function () {
  'use strict';

  var KEY = 'oxx_wishlist';
  var EVT = 'oxx:wishlist:change';
  var REMOVE_SVG =
    '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" aria-hidden="true">' +
    '<path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent(EVT, { detail: { list: list } }));
  }
  function has(id) { return read().some(function (i) { return String(i.id) === String(id); }); }
  function add(item) {
    var list = read();
    if (!list.some(function (i) { return String(i.id) === String(item.id); })) {
      list.push(item);
      write(list);
    }
  }
  function remove(id) {
    write(read().filter(function (i) { return String(i.id) !== String(id); }));
  }
  function toggle(item) { has(item.id) ? remove(item.id) : add(item); }

  function itemFromButton(btn) {
    return {
      id: btn.getAttribute('data-wish-id'),
      handle: btn.getAttribute('data-wish-handle') || '',
      title: btn.getAttribute('data-wish-title') || '',
      vendor: btn.getAttribute('data-wish-vendor') || '',
      image: btn.getAttribute('data-wish-image') || '',
      price: btn.getAttribute('data-wish-price') || '',
      url: btn.getAttribute('data-wish-url') || ''
    };
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // OXX is the retailer, not the maker — never show its house vendor (also
  // guards stale localStorage entries saved before this rule existed).
  function displayVendor(v) {
    var s = String(v == null ? '' : v).trim();
    var norm = s.toLowerCase().replace(/[\s-]/g, '');
    return (norm === 'oxxdesign' || norm === 'oxx') ? '' : s;
  }

  function syncToggleButtons() {
    document.querySelectorAll('[data-oxx-wishlist]').forEach(function (btn) {
      var id = btn.getAttribute('data-wish-id');
      var active = !!(id && has(id));
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function drawerRoot() { return document.getElementById('oxx-wishlist-drawer'); }
  function drawerDialog() { var r = drawerRoot(); return r ? r.querySelector('dialog') : null; }

  function renderDrawer() {
    var list = read();
    document.querySelectorAll('[data-oxx-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.classList.toggle('is-empty', list.length === 0);
      el.toggleAttribute('hidden', list.length === 0);
    });
    var root = drawerRoot();
    if (!root) return;
    var titleEl = root.querySelector('[data-wishlist-title]');
    if (titleEl) {
      var wlLabel = (root.dataset && root.dataset.wishlistLabel) || 'Favourites';
      titleEl.textContent = wlLabel + ' (' + list.length + ')';
    }
    var body = root.querySelector('[data-wishlist-body]');
    var empty = root.querySelector('[data-wishlist-empty]');
    if (empty) empty.hidden = list.length > 0;
    if (!body) return;
    if (list.length === 0) { body.innerHTML = ''; return; }
    body.innerHTML = list.map(function (i) {
      return (
        '<li class="oxx-wishlist__item">' +
          '<a class="oxx-wishlist__thumb" href="' + escapeHtml(i.url) + '">' +
            (i.image ? '<img src="' + escapeHtml(i.image) + '" alt="" loading="lazy">' : '') +
          '</a>' +
          '<div class="oxx-wishlist__info">' +
            '<a class="oxx-wishlist__name" href="' + escapeHtml(i.url) + '">' + escapeHtml(i.title) + '</a>' +
            (displayVendor(i.vendor) ? '<span class="oxx-wishlist__brand">' + escapeHtml(displayVendor(i.vendor)) + '</span>' : '') +
            (i.price ? '<span class="oxx-wishlist__price">' + escapeHtml(i.price) + '</span>' : '') +
          '</div>' +
          '<button type="button" class="oxx-wishlist__remove button-unstyled" data-wish-remove="' +
            escapeHtml(i.id) + '" aria-label="' + escapeHtml((window.oxxI18n && window.oxxI18n.removeFavourite) || 'Usuń z ulubionych') + '">' + REMOVE_SVG + '</button>' +
        '</li>'
      );
    }).join('');
  }

  function openDrawer() {
    var dlg = drawerDialog();
    if (!dlg) return;
    renderDrawer();
    if (dlg.showModal && !dlg.open) dlg.showModal();
    document.documentElement.classList.add('oxx-wishlist-open');
  }
  function closeDrawer() {
    var dlg = drawerDialog();
    if (dlg && dlg.open) dlg.close();
    document.documentElement.classList.remove('oxx-wishlist-open');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var toggleBtn = t.closest('[data-oxx-wishlist]');
    if (toggleBtn) { e.preventDefault(); toggle(itemFromButton(toggleBtn)); return; }
    var openBtn = t.closest('[data-oxx-wishlist-open]');
    if (openBtn) { e.preventDefault(); openDrawer(); return; }
    var closeBtn = t.closest('[data-oxx-wishlist-close]');
    if (closeBtn) { e.preventDefault(); closeDrawer(); return; }
    var rm = t.closest('[data-wish-remove]');
    if (rm) { e.preventDefault(); remove(rm.getAttribute('data-wish-remove')); return; }
  });

  // backdrop click closes (click directly on the dialog element, outside its inner panel)
  document.addEventListener('click', function (e) {
    var dlg = drawerDialog();
    if (dlg && dlg.open && e.target === dlg) closeDrawer();
  });

  document.addEventListener(EVT, function () { syncToggleButtons(); renderDrawer(); });

  function init() {
    var dlg = drawerDialog();
    if (dlg) dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('oxx-wishlist-open');
    });
    syncToggleButtons();
    renderDrawer();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
